import { manifest } from './manifest';
/**
 * 接口配置
 * 取值，例：APIConfig.domain
 * */
export const APIConfig = {
	// 接口地址前缀
	APIPrefix: `${manifest.api_url}/fs-sxzx-api-1.0`,
	// 文件上传接口地址
	UploadUrl: `${manifest.api_url}/fs-sxzx-api-1.0/file/upload`,
	// 证件照上传接口地址
	UploadZjzUrl: `${manifest.api_url}/fs-sxzx-api-1.0/file/uploadzjz`,
	// 新闻图片接口地址
	UploadNewsUrl: `${manifest.api_url}/fs-sxzx-api-1.0/file/newsupload`,
	// 已上传正式文件查看路径
	FileUrl: '/upload/real',
	// 已上传临时文件查看路径
	TempFileUrl: '/upload/tmp',
	// 导出数据文件下载路径
	ExportExcelUrl: '/download',
	// 本地调试用，不为空的话取远程的文件  
};
/**
 * 应用配置
 * 取值，例：APPConfig.UploadAccept
 * */
export const APPConfig = {
	whiteList: ['/user/login', '/user/wxlogin', '/home', '/accountsettings', '/404', '/403', '/', '/h5'],
	noNeedLogin: ['/user/login', '/user/wxlogin', '/home'],
	FileViewUrl: "https://www.songxizx.cn/fileview/onlinePreview",
	TMapUrl: "https://api.tianditu.gov.cn/api?v=4.0&tk=68efc3205061afa1906132d53371a7af",
	// 可上传文件格式
	UploadAccept: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,image/*,.mp4',

	// 可上传文件大小
	UploadMaxSize: 300, // 单位M

	// 默认登录有效时间（天）
	LogonDays: 7, // 天

	// 日期选择组件默认时间区
	DefaultDateRange: {
		time: 1, // 默认1天
		week: 6, // 默认6周
		date: 15, // 默认15天
		month: 6, // 默认6个月
		year: 1, // 默认1年
	},

	// 日期选择组件最大时间区
	MaxDateRange: {
		time: 7, // 最多7天
		week: 12, // 最多12周
		date: 31, // 最多31天
		month: 12, // 最多12个月
		year: 3, // 最多3年
	},

	// 日期选择组件默认结束时间步长
	DefaultEndTimeStep: {
		time: -1, // 天，默认从昨天0点0分到23点59分
		date: -1, // 天，默认到昨天为止
		week: -1, // 周，默认到上周为止
		month: -1, // 月，默认到上月为止
		year: -1, // 年，默认到去年为止
	},

	// 数据模式窗默认大小
	DataModalSize: {
		height: '60vh', // 默认高度
		width: '80%', // 默认宽度
	},

	// 单位名称统一
	UnitName: {
		bigstere: '万m³',
		stere: 'm³',
		square: '㎡',
		people: '人',
		litre: '升',
		personalLitre: '升每人日',
		one: '个',
		pressure: 'MPa',
		temperature: '℃',
		percentage: '%',
		velocity: 'm³/H',
		secondvelocity: 'm³/s'
	},

	passWordRules: { //密码规则
		rules: /^((?=.*\d)(?=.*[_~!@#$^&])|(?=.*[a-zA-Z])(?=.*[_~!@#$^&])|(?=.*[a-zA-Z])(?=.*\d))[a-zA-Z\d_~!@#$^&*]{8,16}$/,
		message: '请输入8-16位密码，至少包含数字/字母/字符（_~!@#$^&）2种组合，不能使用空格、中文，不能含有非法字符！'
	},

	alarmIntervalTime: 60000 * 5, // 5分钟，告警查询轮询时间配置（毫秒）
	DataIntervalTime: 60000 * 10, // 10分钟，页面刷新轮询时间配置（毫秒）
	DataRefreshTime: ['07:50:00', '12:00:00'], // 刷新数据时间
	PageRefreshTime: '05:00:00', // 刷新页面时间
	TablePollingTime: 180000,// 工单列表轮询时间单位毫秒
};


/**
 * 图表配置
 * 取值，例：ChartConfig
 * **/
export const ChartConfig = {
	//图形颜色配置
	// 图表第一个颜色，除了水平衡监测的深色调转换为浅色调，其它直接使用主色调
	shapeColor: [
		...(manifest.theme_color === '#1e5588' ? ['#1890FF'] : [manifest.theme_color, '#1890FF']),
		'#FFC154',
		'#FF6E55',
		'#A576A0',
		'#47B29E',
		'#E84C6B',
		'#F79558',
		'#11A9AE',
		'#4EC4F4',
		'#3668AD',
		'#38A56E',
		'#BAD634',
	],

	legendinactiveColor: '#c5c5c5', // 图表图例关闭时的颜色

	// 图表表线颜色
	markLineColor: {
		aqsw: 'green', // 安全水量
		jjsw: '#fece30', // 警戒水量
		sfsw: '#0065bd', // 设防水量
		bzsw: '#fc4672', // 保证水位
		zdsx: 'red', // 浊度上限
		dmgc: '#ffa300', // 地面高程
		yjyz: '#ff9000', // 一级阀值
		ejyz: '#ff6796', // 一级阀值
	},

	// 单位名称统一
	UnitName: {
		stere: 'm³',
		square: '㎡',
		people: '人',
		litre: '升',
		personalLitre: '升每人日',
		one: '个',
		pressure: 'MPa',
		temperature: '℃',
		percentage: '%',
		velocity: 'm³/H',
		secondvelocity: 'm³/s',
		voltage: 'v',
		signal: 'dbm',
	},
};


